import { styled } from '@mui/system';
import { Button } from '@mui/material';

import COLORS from '../styles/colors.json'

export default styled(Button)({
    color: COLORS.white,
    borderColor: COLORS.almostBlack,
    backgroundColor: COLORS.gray9,
    "&:disabled": {
        backgroundColor: COLORS.gray8,
        borderColor: COLORS.gray7
    },
    '&:hover': {
        backgroundColor: COLORS.gray9
    },
})